import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter, Mutation } from 'vuex-class';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { CUSTOMER_DETAILS, SET_ORG_UNITS } from '@/types/customer.types';
import { CustomerDetailsModel } from '@/models/backoffice/CustomerDetails';
import CustomerSettings from '@/components/backoffice/CustomerSettings';
import OfficesSettings from '@/components/backoffice/OfficesSettings';
import ManagersSettings from '@/components/backoffice/ManagersSettings';
import RemindersSettings from '@/components/backoffice/RemindersSettings';
import MessagesSettings from '@/components/backoffice/MessagesSettings';

@Component({
  components: {
    CustomerSettings,
    ManagersSettings,
    OfficesSettings,
    RemindersSettings,
    MessagesSettings,
  },
})
export default class CustomerDetailsComponent extends Vue {

  @Mutation(SET_ORG_UNITS, StoreNamespace.CUSTOMER) public setOrgUnits;

  @Getter(CUSTOMER_DETAILS, StoreNamespace.CUSTOMER) public customerDetails!: CustomerDetailsModel;

  public mounted() {
    this.setOrgUnits(undefined);
  }
}

